export var CheckType;
(function (CheckType) {
    CheckType["Null"] = "[object Null]";
    CheckType["Undefined"] = "[object Undefined]";
    CheckType["Number"] = "[object Number]";
    CheckType["String"] = "[object String]";
    CheckType["Object"] = "[object Object]";
    CheckType["Function"] = "[object Function]";
})(CheckType || (CheckType = {}));
export function checkType(target) {
    return Object.prototype.toString.call(target);
}
export function shouldConstruct(Component) {
    const prototype = Component.prototype;
    return !!(prototype && prototype.isReactComponent);
}
export function isSimpleFunctionComponent(type) {
    return (checkType(type) === CheckType.Function &&
        !shouldConstruct(type) &&
        type.defaultProps === undefined);
}
export function upperCase(type) {
    const names = type.split('-');
    return names.map((name) => {
        return name.replace(name[0], name[0].toLocaleUpperCase());
    }).join('');
}
export function toLine(name) {
    const newName = name.replace(/([A-Z])/g, "-$1").toLowerCase();
    if (newName[0] === '-') {
        return newName.substr(1);
    }
    return newName;
}
export function infoComponentMessage(type, message) {
    if (isSimpleFunctionComponent(type)) {
        console.log(`[WorkInProgress Info]: FunctionComponent -> ${message}`);
    }
    if (shouldConstruct(type)) {
        console.log(`[WorkInProgress Info]: Component Class -> ${message}`);
    }
}
export function infoNativeMessage(message) {
    console.log(`[WorkInProgress Info]: No Custom Component -> ${message}`);
}
export function errorMessage(message) {
    throw new Error(`[WorkInProgress Error]: ${message}`);
}
export function warnMessage(message) {
    console.warn(`[WorkInProgress Warn]: ${message}`);
}
//# sourceMappingURL=shared.js.map